// Master-Hotfix P0 — structured link-analysis status instead of raw
// "thinking" text while the Universal Link Resolver works on a URL.
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Check, Loader2, Link2 } from "lucide-react";
import { shortLinkLabel } from "../../lib/linkify";

const STEPS = [
  { key: "detected", at: 0 },
  { key: "db", at: 1200 },
  { key: "external", at: 3500 },
  { key: "analysis", at: 9000 },
];

export function LinkAnalysisStatus({ url }) {
  const { t } = useTranslation("ai");
  const [elapsed, setElapsed] = useState(0);
  useEffect(() => {
    const started = Date.now();
    const id = setInterval(() => setElapsed(Date.now() - started), 500);
    return () => clearInterval(id);
  }, []);

  const activeIdx = STEPS.reduce(
    (acc, s, i) => (elapsed >= s.at ? i : acc), 0,
  );

  return (
    <div className="flex justify-start" data-testid="ai-link-analysis-status">
      <div className="w-full max-w-[85%] min-w-0 space-y-2 rounded-2xl border border-zinc-800 bg-zinc-900/80 px-4 py-3 sm:max-w-[75%]">
        <div className="flex min-w-0 items-center gap-2 text-xs text-zinc-400">
          <Link2 className="h-3.5 w-3.5 shrink-0 text-amber-400" />
          <span className="truncate font-medium text-zinc-300">
            {shortLinkLabel(url)}
          </span>
        </div>
        <div className="space-y-1.5">
          {STEPS.map((s, i) => {
            const done = i < activeIdx;
            const active = i === activeIdx;
            return (
              <div
                key={s.key}
                data-testid={`ai-link-status-${s.key}`}
                className={`flex items-center gap-2 text-xs ${
                  done ? "text-emerald-400/90"
                    : active ? "text-zinc-200"
                    : "text-zinc-600"
                }`}
              >
                {done ? (
                  <Check className="h-3 w-3 shrink-0" />
                ) : active ? (
                  <Loader2 className="h-3 w-3 shrink-0 animate-spin text-amber-400" />
                ) : (
                  <span className="h-3 w-3 shrink-0 rounded-full border border-zinc-700" />
                )}
                <span>{t(`linkStatus.${s.key}`)}</span>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
